import styled from 'styled-components';
import { Colors, Breakpoints } from 'styles/Constants';
import BaseBox from 'components/boxes/BaseBox';

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;

  h1 {
    font-size: 18px;
    font-weight: 600;
    color: ${Colors.primaryGray};
    margin: 0;
  }
`;

export const EngagementGrid = styled.div`
  ${BaseBox};
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 30px 0;
  text-align: center;

  @media (min-width: ${Breakpoints.large}) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`;

export const EngagementCard = styled.div`
  position: relative;
  padding: 10px 16px;

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    right: 0;
    top: 10%;
    height: 80%;
    width: 2px;
    background-color: #d8d8d8;
    border-radius: 10px;

    @media (min-width: ${Breakpoints.medium}) {
      width: 4px;
    }
  }

  .label {
    font-size: 0.6875rem;
    font-weight: bold;
    color: #333333;
    margin: 8px 0 0;

    @media (min-width: ${Breakpoints.medium}) {
      font-size: 1rem;
    }
  }

  .value {
    font-size: 24px;
    font-weight: 700;
    color: ${Colors.primaryDarkBlue};
    margin: 0;

    @media (min-width: ${Breakpoints.medium}) {
      font-size: 28px;
    }
  }
`;

export const AveragesSection = styled.div`
  margin-top: 24px;

  h2 {
    font-size: 15px;
    font-weight: 600;
    color: ${Colors.primaryGray};
    margin: 0 0 12px;
  }
`;

export const AveragesGrid = styled.div`
  ${BaseBox};
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 30px 0;
  text-align: center;
`;

export const PostsSection = styled.div`
  margin-top: 24px;

  h2 {
    font-size: 15px;
    font-weight: 600;
    color: ${Colors.primaryGray};
    margin: 0 0 16px;
  }
`;

export const PostsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;

  @media (min-width: ${Breakpoints.medium}) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: ${Breakpoints.large}) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

export const PostCard = styled.a`
  ${BaseBox};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  margin-bottom: 0;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  }

  .post-image {
    width: 100%;
    height: 180px;
    object-fit: cover;
    background-color: #f0f2f5;
  }

  .post-placeholder {
    width: 100%;
    height: 180px;
    background-color: #f0f2f5;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${Colors.primaryLightGray};
    font-size: 32px;
  }

  .post-body {
    padding: 12px 16px;
    flex: 1;
  }

  .post-message {
    font-size: 13px;
    color: ${Colors.primaryGray};
    margin: 0 0 10px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .post-date {
    font-size: 11px;
    color: ${Colors.primaryLightGray};
    margin: 0 0 10px;
  }

  .post-metrics {
    display: flex;
    gap: 16px;
    border-top: 1px solid #f0f2f5;
    padding: 10px 16px;
  }

  .post-metric {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: ${Colors.primaryLightGray};

    span {
      font-weight: 600;
      color: ${Colors.primaryGray};
    }
  }
`;
